import { AlertCircle } from 'lucide-react';
import React, { type ReactNode } from 'react';
import { tv } from 'tailwind-variants';
import { statusVariants, type StatusAppearances, type StatusIntents } from '~/theme/variants';

const pillStyles = tv({
	extend: statusVariants,
	base: 'inline-flex max-w-max items-center gap-2 rounded-full px-2 py-0.5 text-xs font-medium',
	defaultVariants: {
		intent: 'neutral',
		appearance: 'outline'
	}
});

export interface StatusPillProps {
	intent?: StatusIntents;
	appearance?: StatusAppearances;
	className?: string;
	children?: ReactNode;
}

export function StatusPill({ intent = 'neutral', appearance, className, children }: StatusPillProps) {
	return (
		<div className={pillStyles({ intent, appearance, className })}>
			{intent === 'warning' && <AlertCircle size={11} />}
			{children && <span className="truncate">{children}</span>}
		</div>
	);
}
